<template>
    <div class="enterSecretQuestion-screen">
        <div class="leftContent">
            <custom-header :img-number="1"></custom-header>
        </div>
        <div class="rightContent" >
            <div class="wrap enterSecretQuestion_content">
                <div class="grow"></div>
                <h2  v-text="$ml.get('registerAllPinCodeTitle')">Введіть ваш PIN-код</h2>

                <enter-pin-code
                    ref="pincode"
                    v-model="pincode"
                    :title="$ml.get('registerAllPinCodeHelpText')"
                    :errorMessage="isNotValidMessage"
                    @keydown.native.enter="nextScreen"
                />
                <div class="grow"></div>
                <div class="bottom">
                    <div class="left">
                        <custom-button
                                :button-text="$ml.get('back')"
                                back
                                :action="back"
                        ></custom-button>
                    </div>
                    <div class="right">
                        <custom-button
                                :button-text="$ml.get('next')"
                                success
                                :disabled="disabledButton"
                                :action="nextScreen"
                        ></custom-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import CustomHeader from "../../../components/ui/custom-header";
    import CustomButton from "../../../components/ui/custom-button";
    import Profile from '../../../helpers/profile';
    import EnterPinCode from "../../../components/layout/enterPinCode.vue";
    import {setSecretData, verifySecretCode, getApiErrorMessage} from '../../../helpers/api';

    export default {
        name: "setAllPinCodePage",
        components: {
            EnterPinCode,
            CustomButton,
            CustomHeader
        },
        data() {
            return {
                pincode: Profile.pincode,
                isNotValidMessage: '',
                isLoading: false,
            }
        },

        computed: {
            disabledButton: function() {
                return this.pincode.length !== 4 || this.isLoading;
            },
        },

        mounted () {
            this.$refs.pincode.focus();
        },

        created() {
            let isMobile = window.innerWidth < 600;
            if (isMobile) {
                if (Profile.process === 'login')
                    this.$router.replace('/login/infoPinCode');
                else if (Profile.process === 'accessRecovery')
                    this.$router.replace('/accessRecovery/infoPinCode');
                else
                    this.$router.replace({ name: 'RegistrationInfoPinCodePage'});
            }
        },

        methods: {
            nextScreen: function () {
                if (this.isLoading)
                    return;
                this.isNotValidMessage = '';
                Profile.setData({pincode: this.pincode});
                if (Profile.process === "login") {
                    if (Profile.needsetquestion)
                        this.$router.push('/login/infoSecretQuestion');
                    else {
                        //сохраняем пинкод и логинимся с ним
                        this.isLoading = true;
                        setSecretData().then(()=>{
                        }, err => {
                            this.isNotValidMessage = getApiErrorMessage(err);
                        }).finally(()=>{
                            this.isLoading = false;
                        });
                    }
                } else if (Profile.process === "accessRecovery") {
                    this.$router.push('/accessRecovery/infoSecretQuestion');
                } else
                    this.$router.push({ name: 'RegistrationInfoSecretQuestion'});
            },

            back: function () {
                Profile.setData({pincode: ''});
                this.$router.back();
            },

        }

    }
</script>
<style lang="scss">
    .enterSecretQuestion_content {
        .trailingIcon {
            cursor: default !important;
        }
    }
</style>
<style lang="scss" scoped>

        .enterSecretQuestion_content {
            display: flex;
            flex-direction: column;
            min-height: calc(100vh - 150px);
            justify-content: space-between;
            padding: 10% 6% 0;
        }
        .question {
            text-align: left;
            font-weight: 500;
            margin-bottom: 0;
        }
        .prompt {
            text-align: left;
            font-weight: 300;
            font-size: 12px;
            line-height: 16px;
            color: #7B7B7B;
        }
        .link {
            color: #5CD69B;
            font-weight: 300;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            margin: 12px 0;
        }
        .bottom {
            .left {
                width: 40%;
                float: left;
            }
            .right {
                width: 56%;
                float: right;
            }
        }
    @media (min-width: 601px) and (max-width: 750px) {
        .question, .prompt {
            font-size: 18px;
            line-height: 24px;
        }
        .link {
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
        }
        .enterSecretQuestion_content {
            height: calc(100vh - 160px);
            max-height: 700px;
        }
    }
    @media (min-width: 751px) {
        .question, .prompt {
            font-size: 18px;
            line-height: 24px;
        }
        .prompt {
            margin-top: 6px;
        }
        .link {
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
        }
        .enterSecretQuestion_content  {
            height: calc(100vh - 160px);
            max-height: 700px;
        }
    }

</style>